import * as React from 'react';
import * as styles from './style.css';


interface IBubbleContainer {
    title: string;
    children: any;
    containerStyle?: any;
    innerStyle?: any;
    theme?: string
}

const themes = {
    base: {
        title: styles.title,
        inner: styles.inner,
    },
    memorial: {
        title: styles.title_memorial,
        inner: styles.inner_memorial,
    }
}

export default function BubbleContainer({title, children, containerStyle, innerStyle, theme = 'base'}: IBubbleContainer) {
    const themeStyles = themes[theme];

    return (
        <div className={styles.container} style={containerStyle || {}}>
            <div className={themeStyles.title}>
                {title}
            </div>
            <div className={themeStyles.inner} style={innerStyle || {}}>
                {children}
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/bubble-container/index.tsx